import React, { useState } from "react";

import './MapFixed.css';

import { useJsApiLoader } from "@react-google-maps/api";
import { Spinner } from "react-bootstrap";
import Map from "./Map";
import MapDirection from "./MapDirection";
import { MAP_API_KEY } from "config/config";
import { RouteEmergencyService, RouteEmergencyStop } from "Data/interfaces";

type LocationType = {
    id?: number,
    lat: number;
    lng: number;
    status?: string;
}

type DirectionType = {
    origin: LocationType;
    destination: LocationType;
    waypoints?: LocationType[];
    route_emergency_service?: RouteEmergencyService[];
    route_emergency_stop?: RouteEmergencyStop[];

}


interface MapFixedProps {
    location?: Partial<LocationType>;
    isDirection?: boolean;
    route_id?: number;
    hasMarker?: boolean;
    direction?: Partial<DirectionType>;
    isGestureHandling?: boolean;
}

const MapFixed: React.FC<MapFixedProps> = ({ location = {}, hasMarker = false, route_id = undefined, isDirection = false, direction = {}, isGestureHandling = false }) => {
    const [libraries] = useState<Array<'places' | 'routes'>>(['places']);

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: MAP_API_KEY,
        libraries: libraries
    })



    return (
        <div className='mapFixed'>
            {
                !isLoaded ? <Spinner /> :
                    !isDirection ?
                        <Map location={location} setLatLng={() => { }} option={{ gestureHandling: isGestureHandling ? "auto" : 'none' }} className="googleMap" /> :
                        (direction.origin && direction.destination) ? <MapDirection
                            hasMarker={hasMarker}
                            route_id={route_id}
                            origin={direction.origin}
                            destination={direction.destination}
                            waypoints={direction.waypoints}
                            emergency_service={direction.route_emergency_service}
                            emergency_stop={direction.route_emergency_stop}
                        /> : ""

            }
        </div>
    )
}

export default React.memo(MapFixed)